<ul class="dashboard-menu">
  @for (item of definition.menuDefinition; track item) {
    <li>
      <a routerLink="{{ item.href }}" routerLinkActive="active-item" (click)="onSubMenuClick()"
        ><i class="menu-item-i"></i><span class="menu-item-caption">{{ item.caption | translate }}</span></a
        >
      </li>
    }
  </ul>
